function calculateColor(value) {
    if (value < 4.5) return 'red';
    else if (value >= 4.5 && value < 7.6) return 'orange';
    else if (value >= 7.6) return 'green';
}

export {calculateColor};